
import {
    Autocomplete,
    Backdrop,
    Grid,
    IconButton,
    TextField,
    Typography,
  } from "@mui/material";
  import axios from "axios";
  import React, { Fragment, memo, useEffect, useState } from "react";
  import { useDispatch } from "react-redux";
  import { Helmet } from "react-helmet-async";
  import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
  import { useStyle } from "../style";
  import CustomTable from "../customTable";
  import _ from "lodash";
  import moment from "moment";
  
  const StockValueReport = () => {
    const classes = useStyle();
    const dispatch = useDispatch();
    const pageOption = [10, 25, 50, 100];
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [pageCount, setPageCount] = useState(0);
    const [data, setData] = useState([]);
    const [dateLimit, setDateLimit] = useState({
      fromDate: moment().subtract(1, "years").format("YYYY"),
      toDate: moment().format("YYYY"),
    });
  
    const columns = [
      {
        field: "sno",
        headerName: "S.no",
        minWidth: 70,
        maxWidth: 100,
        headerAlign: "center",
        align: "center",
        sortable: false,
      },
      {
        field: "Branch",
        headerName: "Branch",
        flex: 1,
        headerAlign: "center",
        align: "center",
        sortable: false,
      },
      {
        field: "Qty",
        headerName: "Qty",
        flex: 1,
        headerAlign: "center",
        align: "center",
        sortable: false,
      },
      {
        field: "BaseValue",
        headerName: "Base Value",
        flex: 1,
        headerAlign: "center",
        align: "center",
        sortable: false,
      },
      {
        field: "TaxValue",
        headerName: "Tax Value",
        flex: 1,
        headerAlign: "center",
        align: "center",
        sortable: false,
      },
      {
        field: "MRP",
        headerName: "MRP",
        flex: 1,
        headerAlign: "center",
        align: "center",
        sortable: false,
      },
    ];
  
    const rows = _.map(data, (val, idx) => ({
      id: idx,
      sno: idx + 1,
      Branch: val.outlet,
      TaxValue: val.outlet === "Warehouse" ? val.warehouse_tax_value.toFixed(0) : val.outlet_tax_value.toFixed(0),
      MRP: val.outlet === "Warehouse" ? val.warehouse_mrp_sum.toFixed(0) : val.outlet_mrp_sum.toFixed(0),
      BaseValue: val.outlet === "Warehouse" ? val.warehouse_pur_rate_sum.toFixed(0) : val.outlet_pur_rate_sum.toFixed(0),
      Qty: val.qty,
    }));
   
    const calculateTotals = (data) => {
        let totalQty = 0;
        let totalBaseValue = 0;
        let totalTaxValue = 0;
        let totalMRP = 0;
    
        data.forEach((item) => {
          totalQty += item.qty || 0;
          totalBaseValue +=
            item.outlet === "Warehouse" ? item.warehouse_pur_rate_sum : item.outlet_pur_rate_sum || 0;
          totalTaxValue +=
            item.outlet === "Warehouse" ? item.warehouse_tax_value : item.outlet_tax_value || 0;
          totalMRP +=
            item.outlet === "Warehouse" ? item.warehouse_mrp_sum : item.outlet_mrp_sum || 0;
        });
    
        return { totalQty, totalBaseValue, totalTaxValue, totalMRP };
      };
    // Calculate totals for the last row
    const totals = calculateTotals(data);
  
    // Add totals row
    const rowsWithTotals = [
      ...rows,
      {
        id: "totals",
        sno: "Total",
        Branch: "-",
        Qty: totals.totalQty,
        BaseValue: totals.totalBaseValue.toFixed(0),
        TaxValue: totals.totalTaxValue.toFixed(0),
        MRP: totals.totalMRP.toFixed(0),
      },
    ];
 
  
    function handleGetData() {
      axios
        .get(`v1/reports/item/stock/value`)
        .then((res) => {
          setData(res.data);
          setPageCount(res.data.length);
        })
        .catch((err) => {
          dispatch(
            setSnackbar(true, "error", err.response.data.errors?.[0].message)
          );
        });
    }
  
    useEffect(() => {
      if (dateLimit.fromDate !== null && dateLimit.toDate !== null) {
        handleGetData();
      }
    }, [rowsPerPage, page, dateLimit]);
  
    return (
      <Fragment>
        <Helmet>
          <title>Stock Value Report</title>
        </Helmet>
        <Typography variant="h6">Stock Value Report</Typography>
        <Grid container spacing={2} className="p-2 pt-2"></Grid>
        <CustomTable
          props={{
            columns,
            rows: rowsWithTotals ,
            page,
            setPage,
            rowsPerPage,
            setRowsPerPage,
            pageCount,
            pageOption,
          }}
        />
      </Fragment>
    );
  };
  
  export default memo(StockValueReport);
  